import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { navigationRef } from './utils/navigation';
import GlobalStyle from './styles/global-style';
import { Fragment } from 'react';
import { App as AppAntD } from 'antd';
import { Provider } from 'react-redux';
import store from './redux/store.js';
import Alert from './components/alert/alert';
import ErrorBoundary from './components/errorBoundary';
import Loading from './components/loading/loading.jsx';
import LayoutPage from './components/layoutPage';

const AppContainer = () => {
  return (
    <Provider store={store}>
      <Loading>
        <Alert />
        <Router ref={navigationRef}>
          <div />
          <Switch>
            <Route exact component={LayoutPage} />
          </Switch>
        </Router>
      </Loading>
    </Provider>
  );
};

const App = () => {
  return (
    <Fragment>
      <ErrorBoundary>
        <AppAntD>
          <AppContainer />
          <GlobalStyle />
        </AppAntD>
      </ErrorBoundary>
    </Fragment>
  );
};

export default App;
